/* eslint-disable react/no-access-state-in-setstate */
import React from 'react';
import { withRouter } from 'react-router-dom';
import { GoogleMap } from '@react-google-maps/api';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import VehicleMarker from '../map/vehicle-marker';
import LocationMarker from '../map/marker-location';
import { isOnMobile } from '../../../lib/utils';

const MarkerTypes = {
  VEHICLE: 0,
  LOCATION: 1,
};

const styles = {
  mapDiv: {
    height: '450px',
    width: isOnMobile() ? '320px' : '744px',
    marginTop: isOnMobile() ? '28px' : '0',
  },
};

function BasicMap({
  zoom, center, renderLocationAndVehicleMarkers,
}) {
  return (
    <GoogleMap
      mapContainerStyle={{ width: '100%', height: '100%' }}
      zoom={zoom}
      center={center}
    >
      {renderLocationAndVehicleMarkers()}
    </GoogleMap>
  );
}

class RunMap extends React.Component {
  static DEFAULT_ZOOM_LEVEL = 10;

  static DEFAULT_LAT = 0;

  static DEFAULT_LNG = 0;

  static DEFAULT_CENTER = { lat: RunMap.DEFAULT_LAT, lng: RunMap.DEFAULT_LNG };

  constructor(props) {
    super(props);
    const { selectedMarket } = props;

    const selectedMarketGeo = get(selectedMarket, 'geo.coordinates', [RunMap.DEFAULT_LNG, RunMap.DEFAULT_LAT]);
    const marketCenter = { lat: selectedMarketGeo[1], lng: selectedMarketGeo[0] };

    const center = marketCenter || RunMap.DEFAULT_CENTER;
    const zoom = RunMap.DEFAULT_ZOOM_LEVEL;

    this.state = {
      zoom,
      center,
      selectedMarkerId: null,
      selectedMarkerType: null,
    };

    this.renderLocationAndVehicleMarkers = this.renderLocationAndVehicleMarkers.bind(this);
    this.setSelectedMarker = this.setSelectedMarker.bind(this);
  }

  setSelectedMarker(id, type) {
    this.setState({
      ...this.state,
      selectedMarkerId: id,
      selectedMarkerType: type,
    });
  }

  renderLocationAndVehicleMarkers() {
    const { vehiclesAndLocations } = this.props;
    const { selectedMarkerId } = this.state;

    if (!vehiclesAndLocations) {
      return;
    }
    return vehiclesAndLocations.map((item, index) => {
      // if item is a vehicle
      if (item.humanId) {
        return (
          <VehicleMarker
            key={item._id}
            vehicle={item}
            isSelected={selectedMarkerId === item._id}
            isRun
            readOnly
            vehicleIndex={index}
            onClick={(vehicle) => this.setSelectedMarker(vehicle._id, MarkerTypes.VEHICLE)}
          />
        );
      } else {
        return (
          <LocationMarker
            key={item._id}
            location={item}
            isSelected={selectedMarkerId === item._id}
            isRun
            readOnly
            locationIndex={index}
            onClick={(location) => this.setSelectedMarker(location._id, MarkerTypes.LOCATION)}
          />
        );
      }
    });
  }

  render() {
    const { zoom, center } = this.state;

    return (
      <div>
        <div id="run-map" style={styles.mapDiv}>
          <BasicMap
            zoom={zoom}
            center={center}
            renderLocationAndVehicleMarkers={this.renderLocationAndVehicleMarkers}
            containerElement={<div style={{ height: '100%' }} />}
            mapElement={<div style={{ height: '100%' }} />}
          />
        </div>
      </div>
    );
  }
}
RunMap.propTypes = {
  vehiclesAndLocations: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string,
    }).isRequired,
  ).isRequired,
};

export default withRouter(RunMap);
